module.exports = function _btoa(str) {
  return btoa(str)
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/btoa-lite/btoa-browser.js
 ** module id = 820
 ** module chunks = 0
 **/